<template>
    <section class="testimonials-section py-5 bg-light">
        <!-- <div class="container">
            <div class="text-center mb-5">
                <h2 class="section-title">Co mówią o nas klienci</h2>
                <p class="section-subtitle">Poznaj opinie firm, które nam zaufały</p>
            </div>

            <div class="testimonials-slider">
                <div class="row">
                    <div class="col-md-4 mb-4" v-for="(testimonial, index) in testimonials" :key="index">
                        <div class="testimonial-card h-100 p-4 bg-white rounded shadow-sm">
                            <div class="testimonial-content mb-4">
                                <div class="quote-icon mb-3">
                                    <i class="fas fa-quote-left fa-2x text-primary opacity-25"></i>
                                </div>
                                <p class="testimonial-text">{{ testimonial.text }}</p>
                            </div>

                            <div class="testimonial-author d-flex align-items-center">
                                <div class="author-avatar me-3">
                                    <img :src="testimonial.avatar" :alt="testimonial.name" class="rounded-circle">
                                </div>
                                <div class="author-info">
                                    <h5 class="author-name mb-1">{{ testimonial.name }}</h5>
                                    <p class="author-position mb-0">{{ testimonial.position }}, {{ testimonial.company
                                    }}</p>
                                </div>
                            </div>

                            <div class="testimonial-rating mt-3">
                                <i class="fas fa-star text-warning" v-for="star in 5" :key="star"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <button class="btn btn-sm btn-outline-primary mx-2">&laquo; Poprzednie</button>
                    <button class="btn btn-sm btn-outline-primary mx-2">Następne &raquo;</button>
                </div>
            </div>

            <div class="client-logos mt-5">
                <h4 class="text-center mb-4">Zaufali nam</h4>
                <div class="row align-items-center justify-content-center">
                    <div class="col-6 col-md-2 mb-4 mb-md-0" v-for="(logo, index) in clientLogos" :key="index">
                        <div class="logo-item text-center">
                            <img :src="logo.src" :alt="logo.alt" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </section>
</template>

<script>
export default {
    name: 'TestimonialsSection',
    data() {
        return {
            testimonials: [
                {
                    text: "Współpracujemy z Selam Rachunkowość od ponad 3 lat i jesteśmy bardzo zadowoleni z ich usług. Profesjonalizm, terminowość i indywidualne podejście to ich główne atuty. Polecam każdej firmie szukającej solidnego partnera w obszarze księgowości.",
                    name: "Anna Nowak",
                    position: "Dyrektor Finansowy",
                    company: "Tech Solutions Sp. z o.o.",
                    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
                },
                {
                    text: "Dzięki współpracy z Selam Rachunkowość mogę skupić się na rozwoju mojej firmy, mając pewność, że sprawy księgowe są w dobrych rękach. Zawsze otrzymuję szybką i kompetentną pomoc w kwestiach podatkowych.",
                    name: "Marek Kowalski",
                    position: "Właściciel",
                    company: "MK Design",
                    avatar: "https://randomuser.me/api/portraits/men/54.jpg",
                },
                {
                    text: "Profesjonalne podejście, rzetelność i elastyczność - to cechy, które cenię najbardziej we współpracy z Selam Rachunkowość. Od kiedy powierzyłam im księgowość mojej firmy, mogę spać spokojnie.",
                    name: "Katarzyna Wiśniewska",
                    position: "CEO",
                    company: "Beauty Spot",
                    avatar: "https://randomuser.me/api/portraits/women/33.jpg",
                }
            ],
            clientLogos: [
                {
                    src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/1200px-Google_2015_logo.svg.png',
                    alt: "Logo Google"
                },
                {
                    src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Apple_logo_black.svg/1667px-Apple_logo_black.svg.png',
                    alt: "Logo Apple"
                },
                {
                    src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/2048px-Microsoft_logo.svg.png',
                    alt: "Logo Microsoft"
                },
                {
                    src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/2560px-Amazon_logo.svg.png',
                    alt: "Logo Amazon"
                },
                {
                    src: 'https://upload.wikimedia.org/wikipedia/en/thumb/0/04/Facebook_f_logo_%282021%29.svg/800px-Facebook_f_logo_%282021%29.svg.png',
                    alt: "Logo Facebook"
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.testimonials-section {
    background-color: #f8f9fa;

    .section-title {
        color: var(--primary-color);
        margin-bottom: 1rem;
    }

    .section-subtitle {
        color: #6c757d;
        max-width: 600px;
        margin: 0 auto;
    }

    .testimonial-card {
        transition: transform 0.3s ease;

        &:hover {
            transform: translateY(-10px);
        }

        .testimonial-text {
            font-style: italic;
            color: #6c757d;
            line-height: 1.6;
        }

        .author-avatar {
            width: 50px;
            height: 50px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .author-name {
            color: var(--primary-color);
            font-size: 1.1rem;
        }

        .author-position {
            font-size: 0.85rem;
            color: #6c757d;
        }
    }

    .client-logos {
        h4 {
            color: var(--primary-color);
        }

        .logo-item {
            opacity: 0.7;
            transition: opacity 0.3s ease;

            &:hover {
                opacity: 1;
            }

            img {
                max-height: 60px;
            }
        }
    }
}
</style>